var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--primary-blue-200)",
    width: 54,
    height: 54,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0565FF",
    width: 31.5,
    height: 31.5,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.75a2 2 0 110 4 2 2 0 010-4zm13 1a1 1 0 010 2h-8a1 1 0 110-2h8zm-13-7a2 2 0 110 4 2 2 0 010-4zm13 1a1 1 0 110 2h-8a1 1 0 110-2h8zm-13-7a2 2 0 110 4 2 2 0 010-4zm13 1a1 1 0 010 2h-8a1 1 0 110-2h8z",
    fill: "#FFFFFC"
  })))));
}
export default SvgList;